export enum ElementId {
  Embed = "paragraph--type-embed",
  Youtube = "paragraph--type-youtube-video",
  Brightcove = "paragraph--type-sph-brightcove-video",
  OmnyPodcast = "paragraph--type-omny-podcast",
  Box = "paragraph--type-box",
  Graphics = "paragraph--type-graphics",
  Table = "paragraph--type-table",
  Quote = "paragraph--type-sidebar-quotebox",
  Datawrapper = "paragraph--type-data-wrapper",
  Podcast = "paragraph--type-podcast",
  DynamicIframe = "paragraph--type-ceros-embed",
  Flourish = "paragraph--type-flourish",
  X = "paragraph--type-x",
  Instagram = "paragraph--type-instagram",
  Tiktok = "paragraph--type-tiktok",
  Facebook = "paragraph--type-facebook",
  Image = "paragraph--type-inline-image",
  Accordion = "paragraph--type-accordion",
  BoxTitle = "paragraph--type-box-title",
  YoutubeEmbed = "paragraph--type-youtube",
}

export enum EmbedType {
  Flourish = "flourish",
  X = "x",
  Instagram = "instagram",
  Tiktok = "tiktok",
  Facebook = "facebook",
  Embed = "embed",
}
